<script>
  import { createEventDispatcher } from 'svelte';
  import { formatRelative } from 'date-fns';
  import { es } from 'date-fns/locale';
  import { pagination } from '../helpers';

  export let productDownload = { loading, productId, error }, products, pages, currentPage;

  const dispatch = createEventDispatcher();

  let now = new Date();

  function handlePageClick(page) {
    dispatch('pageChange', { page });
  }

  function handleClickDownload(productId, downloadId) {
    dispatch('clickDownload', { productId, downloadId })
  }
</script>

{#if products.length}
  <div class="ui three stackable cards">
    {#each products as { id, name, date_modified, images, price_html, attributes, permalink, downloadable, downloads, view_button_style, download_button_style }}
      <div class="card">
        {#if images.length}
          <a class="image" href={permalink}>
            <img alt={name} src={images[0].src}>
          </a>
        {/if}
        <div class="content">
          <a class="header" href={permalink}>{name}</a>
          <div class="meta">
            <span class="date">Updated { formatRelative(new Date(date_modified), now) }</span>
          </div>
          <div class="description">
            <p>{@html price_html}</p>
            <div class="ui list">
              {#each attributes as { name, visible, options }}
                <div class="item">
                  <i class="check icon"></i>
                  {name}: {@html options.length ? options[0] : ''}
                </div>
              {/each}
            </div>
            {#if productDownload.productId === id && productDownload.error }
              <div class="ui visible negative message">
                <p>{productDownload.error}</p>
              </div>
            {/if}
          </div>
        </div>
        <div class="extra content center aligned">
          <div class="ui buttons">
            <a class="ui button" target="_blank" href={permalink} style={view_button_style}>View</a>
            {#if downloadable && downloads.length}
              <button class="ui icon positive button" style={download_button_style} on:click={() => handleClickDownload(id, downloads[0].id)}
                class:disabled={productDownload.productId === id && productDownload.loading}
                class:loading={productDownload.productId === id && productDownload.loading}
              >
                Download <i class="download icon"></i>
              </button>
            {/if}
          </div>
        </div>
      </div>
    {/each}
  </div>
  {#if pages > 1}
    <div class="pagination-wrapper">
      <div class="ui pagination menu">
        {#each pagination(currentPage, pages) as page}
          {#if Number.isInteger(page)}
            <a href="?page={page}" class="item" class:active={currentPage === page} on:click|preventDefault={() => handlePageClick(page)}>
              {page}
            </a>
          {:else}
            <div class="disabled item">{page}</div>
          {/if}
        {/each}
      </div>
    </div>
  {/if}
{:else}
	<p>No product was found</p>
{/if}

<style>
.ui.cards {
  margin-bottom: 1rem;
}

.ui.cards > .card {
  font-size: 18px;
}

.ui.cards > .card > .content > a.header {
  font-size: 20px;
  text-decoration: none;
}

.ui.buttons > .button {
  font-size: 14px;
}

.pagination-wrapper {
  border-top: 1px solid rgba(34,36,38,.15);
  padding: 1rem;
  text-align: center;
}
</style>